import { render, staticRenderFns } from "./listSwitch.vue?vue&type=template&id=1bf4e7b9&scoped=true"
import script from "./listSwitch.vue?vue&type=script&lang=js"
export * from "./listSwitch.vue?vue&type=script&lang=js"
import style0 from "./listSwitch.vue?vue&type=style&index=0&id=1bf4e7b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf4e7b9",
  null
  
)

export default component.exports